import React from "react";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Clock3, FileText, Layers3 } from "lucide-react";
import MockNavigation from "./MockNavigation";
import KeyBoardCheckPage from "./KeyboardCheckPage";
import HeadphoneCheckPage from "./HeadphonePage";
import MicrophoneCheckPage from "./MicrophonePage";
import TestIntroductionPage from "./TestIntroduction";
import SpeakingInstructionPage from "./SpeakingInstruction";
import FullSectionPage from "./FullSectionTable";
import SectionPage from "./SectionPage";
import PersonalIntroductionPage from "./PersonalIntroductionPage";
import ReadAloudPage from "./Speaking/ReadAloudPage";
import RepeatSentencePage from "./Speaking/RepeatSentencePage";
import DescribeImageMockPage from "./Speaking/DescribeImageMock";
import ReTellMockPage from "./Speaking/ReTellMock";
import ShortAnswersMockPage from "./Speaking/ShortAnswersMock";
import SummarizeGroupDisscusionMockPage from "./Speaking/SummarizeGroupDiscussionMock";
import RespondToSituationMockPage from "./Speaking/RespondToSituation";
import SummarizeMockPage from "./Writing/SummarizeMock";
import WriteEssayMockPage from "./Writing/WriteEssay";
import MultipleTypeSingleMockPage from "./Reading/MultipleTypeSingleMock";
import MultipleTypeDoubleMockPage from "./Reading/MultipleDoubleTypleMock";
import ReArrangeSentenceMockPage from "./Reading/ReArrangeMock";
import ReadingFillInTheBlanksMockPage from "./Reading/ReadingFillInTheBlanksMock";
import FillInTheBlanksReadingAndWritingMockPage from "./Reading/FillInTheBlanksReadingAndWritingMock";
import SummarizeSpokenTestMockPage from "./Listening/SummarizeSpokenTextMock";
import MCQSingleAnswerMockPage from "./Listening/MCQSingleAnswerMock";
import MCQMultipleAnswerMockPage from "./Listening/MCQMultipleAnswerMock";
import FillInTheBlanksMockPage from "./Listening/FillInTheBlanksMock";
import HighlightCorrectSummaryMockPage from "./Listening/HighlightCorrectSummaryMock";
import SelectMissingWordsMockPage from "./Listening/SelectMissingWordMock";
import HighlightIncorrectWordMockPage from "./Listening/HighlightIncorrectWordMock";
import WriteFromDictationMockPage from "./Listening/WriteFromDictationMock";
import Notification from "../QuestionPage/Notification";
import ConfirmDialog from "./PopUp";
import Loading from "./SpinnerLoading"; // Import the loading component
import Timer from "./Timer";
import TimeoutPopup from "./TimeoutPopup";

// function ConfirmDialog({ message, onConfirm, onCancel }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         backgroundColor: "white",
//         border: "1px solid #ccc",
//         padding: "20px",
//         zIndex: 1000,
//       }}
//     >
//       <p>{message}</p>
//       <button onClick={onConfirm}>Yes</button>
//       <button onClick={onCancel}>No</button>
//     </div>
//   );
// }

// Page Html
export default function FullMockTestPage() {
  const navigate = useNavigate();
  const [MockData, setMockData] = useState({
    data: [],
  });
  const [userInputs, setUserInputs] = useState({});

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const [hasAutoSubmitted, setHasAutoSubmitted] = useState(false);

  useEffect(() => {
    const fetchMockData = async () => {
      try {
        setLoading(true);
        const response = await fetch("/api/mockquestions/all", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setMockData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch MockTest data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching MockTest data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchMockData();
  }, []);

  console.log("Mock Data:", MockData.data.AnswershortQuestion);

  const handleInputChange = (questionType, questionIndex, answer) => {
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [questionType]: {
        ...prevInputs[questionType],
        [questionIndex]: answer,
      },
    }));
  };

  console.log("User Input", userInputs);

  const splitData = (data, size) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    const payload = { userInputs, MockData }; // Assuming userInputs and MockData are defined
    const payloadString = JSON.stringify(payload);
    const maxChunkSize = 50000; // Reduce the chunk size further (e.g., 50KB)
    const chunks = splitData(payloadString, maxChunkSize);
    let finalResponse = null;

    console.log(`Total chunks: ${chunks.length}`);

    try {
      setIsSubmitting(true);
      for (const [index, chunk] of chunks.entries()) {
        console.log(`Sending chunk ${index + 1} of ${chunks.length}`);
        const response = await fetch("/api/save-fullmocktestdata", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ chunk, index, totalChunks: chunks.length }),
        });
        if (!response.ok) {
          console.error("Failed to submit data chunk. Status:", response.status);
          throw new Error(`Failed to submit data chunk. Status: ${response.status}`);
        }

        finalResponse = await response.json();
      }
      console.log("Data submitted successfully");
      setMessage("Mock data saved successfully!");
      setNotificationType("success");
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setLoading(false);
        setIsSubmitting(false);
        if (finalResponse?.id) {
          navigate(`/mockpage/result/${finalResponse.id}`);
        } else {
          navigate("/mockpage/result");
        }
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      setMessage("Failed to save MockTest.");
      setNotificationType("error");
      setShowNotification(true); // Show error notification
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const handleTimeout = () => {
    if (hasAutoSubmitted || isSubmitting) return;
    setHasAutoSubmitted(true);
    setShowConfirmDialog(false);
    setShowTimeoutPopup(true);
    handleSubmit();
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Empty dependency array to fetch data only once on mount
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 70;
  const totalQuestionPages = totalPages - 8;
  const handleNext = () => {
    setShowConfirmDialog(true);
    setNextPage(Math.min(currentPage + 1, totalPages));
  };

  const handleConfirm = () => {
    setShowConfirmDialog(false);
    setIsLoading(true); // Start loading

    // Set timeout to simulate loading delay
    setTimeout(() => {
      setIsLoading(false); // End loading
      setCurrentPage(nextPage); // Proceed to the next page
    }, 100);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false); // Hide the confirmation dialog
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const disableNext = currentPage === totalPages;
  const disablePrevious = currentPage === 1;
  const testStarted = currentPage >= 9;
  const questionPageNumber = testStarted ? currentPage - 8 : 0;
  const pageProgress = Math.round((currentPage / totalPages) * 100);
  const attemptedResponses = Object.values(userInputs).reduce((total, answers) => {
    if (!answers || typeof answers !== "object") return total;

    return (
      total +
      Object.values(answers).filter((answer) => {
        if (Array.isArray(answer)) return answer.length > 0;
        if (typeof answer === "string") return answer.trim().length > 0;
        return Boolean(answer);
      }).length
    );
  }, 0);

  const getCurrentSection = () => {
    if (currentPage < 9) return "System checks";
    if (currentPage <= 40) return "Speaking";
    if (currentPage <= 43) return "Writing";
    if (currentPage <= 57) return "Reading";
    return "Listening";
  };

  const renderPage = () => {
    // Check the range of pages 9 to 11 first
    if (currentPage >= 9 && currentPage <= 14) {
      const questionIndex = currentPage - 9;
      const currentQuestion = MockData.data.Readaloud?.[questionIndex];
      return (
        <ReadAloudPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("Readaloud", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
        />
      );
    }
    if (currentPage >= 15 && currentPage <= 26) {
      const questionIndex = currentPage - 15;
      const currentQuestion = MockData.data.RepeatSentence?.[questionIndex];
      return (
        <RepeatSentencePage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("RepeatSentence", questionIndex, answer)
          }
          questionNumber={questionIndex + 7} // Pass question number
        />
      );
    }
    if (currentPage >= 27 && currentPage <= 29) {
      const questionIndex = currentPage - 27;
      const currentQuestion = MockData.data.DescribeImage?.[questionIndex];
      return (
        <DescribeImageMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("DescribeImage", questionIndex, answer)
          }
          questionNumber={questionIndex + 19}
        />
      );
    }
    if (currentPage >= 30 && currentPage <= 31) {
      const questionIndex = currentPage - 30;
      const currentQuestion = MockData.data.RetellLecture?.[questionIndex];
      return (
        <ReTellMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReTellLecture", questionIndex, answer)
          }
          questionNumber={questionIndex + 22}
        />
      );
    }
    if (currentPage >= 32 && currentPage <= 36) {
      const questionIndex = currentPage - 32;
      const currentQuestion = MockData.data.AnswershortQuestion?.[questionIndex];
      return (
        <ShortAnswersMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("AnswershortQuestion", questionIndex, answer)
          }
          questionNumber={questionIndex + 24}
        />
      );
    }
    if (currentPage >= 37 && currentPage <= 38) {
      const questionIndex = currentPage - 37;
      const currentQuestion = MockData.data.SummarizeGroupDiscussion?.[questionIndex];
      return (
        <SummarizeGroupDisscusionMockPage
          key={currentPage}
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeGroupDiscussion", questionIndex, answer)
          }
          questionNumber={questionIndex + 29}
        />
      );
    }
    if (currentPage >= 39 && currentPage <= 40) {
      const questionIndex = currentPage - 39;
      const currentQuestion = MockData.data.RespondToSituation?.[questionIndex];
      return (
        <RespondToSituationMockPage
          key={currentPage}
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("RespondToSituation", questionIndex, answer)
          }
          questionNumber={questionIndex + 31}
        />
      );
    }
    if (currentPage >= 41 && currentPage <= 42) {
      const questionIndex = currentPage - 41;
      const currentQuestion = MockData.data.SummarizeText?.[questionIndex];
      return (
        <SummarizeMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeText", questionIndex, answer)
          }
          questionNumber={questionIndex + 33}
        />
      );
    }
    if (currentPage >= 43 && currentPage <= 43) {
      const questionIndex = currentPage - 43;
      const currentQuestion = MockData.data.WriteEssay?.[questionIndex];
      return (
        <WriteEssayMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("WriteEssay", questionIndex, answer)
          }
          questionNumber={questionIndex + 35}
        />
      );
    }
    if (currentPage >= 44 && currentPage <= 44) {
      const questionIndex = currentPage - 44;
      const currentQuestion = MockData.data.SingleAnswer?.[questionIndex];
      return (
        <MultipleTypeSingleMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SingleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
        />
      );
    }
    if (currentPage >= 45 && currentPage <= 45) {
      const questionIndex = currentPage - 45;
      const currentQuestion = MockData.data.DoubleAnswer?.[questionIndex];
      return (
        <MultipleTypeDoubleMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("DoubleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 2}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 46 && currentPage <= 47) {
      const questionIndex = currentPage - 46;
      const currentQuestion = MockData.data.ReorderParagraph?.[questionIndex];
      return (
        <ReArrangeSentenceMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReorderParagraph", questionIndex, answer)
          }
          questionNumber={questionIndex + 3}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 48 && currentPage <= 52) {
      const questionIndex = currentPage - 48;
      const currentQuestion = MockData.data.FillInTheBlank?.[questionIndex];
      return (
        <ReadingFillInTheBlanksMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("FillInTheBlank", questionIndex, answer)
          }
          questionNumber={questionIndex + 5}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 53 && currentPage <= 57) {
      const questionIndex = currentPage - 53;
      const currentQuestion = MockData.data.ReadingandWriting?.[questionIndex];
      return (
        <FillInTheBlanksReadingAndWritingMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReadingandWriting", questionIndex, answer)
          }
          questionNumber={questionIndex + 10}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 58 && currentPage <= 59) {
      const questionIndex = currentPage - 58;
      const currentQuestion = MockData.data.SummarizeSpokenText?.[questionIndex];
      return (
        <SummarizeSpokenTestMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeSpokenText", questionIndex, answer)
          }
          questionNumber={questionIndex + 15}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 60 && currentPage <= 60) {
      const questionIndex = currentPage - 60;
      const currentQuestion = MockData.data.McqSingleAnswer?.[questionIndex];
      return (
        <MCQSingleAnswerMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("McqSingleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 61 && currentPage <= 61) {
      const questionIndex = currentPage - 61;
      const currentQuestion = MockData.data.McqDoubleAnswer?.[questionIndex];
      return (
        <MCQMultipleAnswerMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("McqDoubleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 2}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 62 && currentPage <= 63) {
      const questionIndex = currentPage - 62;
      const currentQuestion = MockData.data.FillBlank?.[questionIndex];
      return (
        <FillInTheBlanksMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("FillBlank", questionIndex, answer)
          }
          questionNumber={questionIndex + 3}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 64 && currentPage <= 64) {
      const questionIndex = currentPage - 64;
      const currentQuestion = MockData.data.HighlightSummary?.[questionIndex];
      return (
        <HighlightCorrectSummaryMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("HighlightSummary", questionIndex, answer)
          }
          questionNumber={questionIndex + 5}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 65 && currentPage <= 65) {
      const questionIndex = currentPage - 65;
      const currentQuestion = MockData.data.MissingWord?.[questionIndex];
      return (
        <SelectMissingWordsMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("MissingWord", questionIndex, answer)
          }
          questionNumber={questionIndex + 6}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 66 && currentPage <= 67) {
      const questionIndex = currentPage - 66;
      const currentQuestion = MockData.data.IncorrectWord?.[questionIndex];
      return (
        <HighlightIncorrectWordMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("IncorrectWord", questionIndex, answer)
          }
          questionNumber={questionIndex + 7}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 68 && currentPage <= 70) {
      const questionIndex = currentPage - 68;
      const currentQuestion = MockData.data.WritefromDictation?.[questionIndex];
      return (
        <WriteFromDictationMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("WritefromDictation", questionIndex, answer)
          }
          questionNumber={questionIndex + 9}
          maxQuestion={11}
        />
      );
    }

    switch (currentPage) {
      case 1:
        return <HeadphoneCheckPage />;
      case 2:
        return <MicrophoneCheckPage />;
      case 3:
        return <KeyBoardCheckPage />;
      case 4:
        return <TestIntroductionPage />;
      case 5:
        return <SpeakingInstructionPage />;
      case 6:
        return <FullSectionPage />;
      case 7:
        return <SectionPage />;
      case 8:
        return (
          <PersonalIntroductionPage
            onInputChange={(answer) =>
              handleInputChange("PersonalIntroduction", answer)
            }
          />
        );

      // case 26:
      //   return <WriteFromDictationMockPage />;

      default:
        return null;
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-gray-800">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur">
        <div className="w-full px-4 py-3 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 place-items-center rounded-md bg-violet-50 text-violet-700 ring-1 ring-violet-100">
                <Layers3 className="h-5 w-5" aria-hidden="true" />
              </span>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-violet-700">
                  PTE Full Mock Test
                </p>
                <h1 className="text-lg font-extrabold text-gray-900 sm:text-xl">
                  {getCurrentSection()} section
                </h1>
              </div>
            </div>

            <div className="grid gap-2 sm:grid-cols-3 lg:min-w-[560px]">
              <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2">
                <FileText className="h-4 w-4 text-violet-700" aria-hidden="true" />
                <div>
                  <p className="text-[11px] font-bold uppercase text-gray-500">
                    Progress
                  </p>
                  <p className="text-sm font-extrabold text-gray-900">
                    Page {currentPage}/{totalPages}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2">
                <CheckCircle2 className="h-4 w-4 text-violet-700" aria-hidden="true" />
                <div>
                  <p className="text-[11px] font-bold uppercase text-gray-500">
                    Responses
                  </p>
                  <p className="text-sm font-extrabold text-gray-900">
                    {attemptedResponses}/{totalQuestionPages}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 rounded-md border border-violet-100 bg-violet-50 px-3 py-2 text-violet-800">
                <Clock3 className="h-4 w-4" aria-hidden="true" />
                <div>
                  <p className="text-[11px] font-bold uppercase">Time</p>
                  <div className="text-sm font-extrabold">
                    {testStarted ? (
                      <Timer
                        initialMinutes={146}
                        initialSeconds={0}
                        Text="Remaining"
                        onComplete={handleTimeout}
                      />
                    ) : (
                      "Not started"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 h-2 overflow-hidden rounded-sm bg-slate-100">
            <div
              className="h-full rounded-sm bg-violet-600 transition-all duration-300"
              style={{ width: `${pageProgress}%` }}
            />
          </div>

          {testStarted && (
            <p className="mt-2 text-xs font-semibold text-gray-500">
              Question screen {questionPageNumber} of {totalQuestionPages}
            </p>
          )}
        </div>
      </header>

      <main className="w-full flex-1 px-3 py-5 sm:px-5 lg:px-8">
        <div className="full-mock-ui mx-auto w-full max-w-none">
          {loading ? <Loading /> : renderPage()}
        </div>
      </main>

      {isLoading && <Loading />}
      {showTimeoutPopup && <TimeoutPopup />}
      {showConfirmDialog && (
        <ConfirmDialog
          message="Proceed to the next question?"
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}

      <MockNavigation
        onNext={handleNext}
        onPrevious={handlePrevious}
        disableNext={disableNext}
        disablePrevious={disablePrevious}
        currentPage={currentPage} // Pass currentPage here
        totalPages={totalPages} // Pass totalPages here
        handleSubmit={handleSubmit} // Pass handleSubmit here
        isSubmitting={isSubmitting}
      />

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}
